import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const pullRequestsAppBuilder = DataRouterApplicationBuilder.create('pull-requests', {
  queryKeyAppName: () => 'repo',
})
